<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <date-picker
                            v-model="search.date"
                            lang="en"
                            range
                            :format="changeFormat"
                            :lang="lang"
                            confirm
                            placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                        </date-picker>&nbsp;&nbsp;
                        <b-form-select :options="optionProductType"
                                       v-model="search.product_type_id">
                        </b-form-select>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-success" @click="getSpecialCustomerPage(1)">
                            <icon name="search"></icon>
                            ค้นหา
                        </button> &nbsp;
                        <button type="button" class="btn btn-primary" @click="printSpecialCustomerData">
                            <icon name="print"></icon>
                            พิมพ์รายงาน
                        </button>
                    </form>
                </div>
            </nav>
            <div v-if="special_customer_data.length > 0" style="padding: 10px">
                <b>รหัสลูกค้า</b> : {{ special_customer_data[0].customer.customer_id }} &nbsp;&nbsp;&nbsp;
                <b>ชื่อลูกค้า</b> : {{ special_customer_data[0].customer.name }}<br>
                <b>ที่อยู่</b> : {{ special_customer_data[0].customer.address }}
                <template v-if="special_customer_data[0].customer.district">
                    {{ special_customer_data[0].customer.district.name }}
                </template>
                <template v-if="special_customer_data[0].customer.sub_district">
                    {{ special_customer_data[0].customer.sub_district.name }}
                </template>
                <template v-if="special_customer_data[0].customer.province">
                    {{ special_customer_data[0].customer.province.name }}
                </template>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">เลขที่ใบจอง</th>
                        <th scope="col">วันที่</th>
                        <th scope="col">รหัสสินค้า</th>
                        <th scope="col">ขนาดบรรจุ / ห่อ</th>
                        <th scope="col">จำนวน / ห่อ</th>
                        <th scope="col">ราคา / หน่วย</th>
                        <th scope="col">จำนวนเงิน</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="invoices in special_customer_data">
                        <tr>
                            <td>{{ invoices.invoice_id }}</td>
                            <td>{{ invoices.date | moment("DD/MM/YYYY") }}</td>
                            <td>
                                <template v-for="data in invoices.details">
                                    {{ data.product ? data.product.sku : '' }}<br/>
                                </template>
                            </td>
                            <td>
                                <template v-for="data in invoices.details">
                                    <span v-if="data.product && data.product.pack">
                                        {{ data.product && data.product.pack ? data.product.pack.number : '' }}<br/>
                                    </span>
                                </template>
                            </td>
                            <td>
                                <template v-for="data in invoices.details">
                                    {{ data.quantity | amount }}<br/>
                                </template>
                            </td>
                            <td>
                                <template v-for="data in invoices.details">
                                    {{ data.price | currency }}<br/>
                                </template>
                            </td>
                            <td>
                                <template v-for="data in invoices.details">
                                    {{ data.price | currency }}<br/>
                                </template>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSpecialCustomerPage(dataPaginate.current_page)">
            </vue-pagination>
            <b-modal hide-footer hide-header ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
            </b-modal>
        </div>
        <!--        <pre class="alert-primary">{{search}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";

export default {
    name: "special-customer-form",
    components: {
        Loading,
        VuePagination,
        DatePicker
    },
    props: {
        customer_id: {default: null}
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            log_status: null,
            items: [
                {
                    text: "รายการลูกค้าพิเศษ",
                    to: {name: "special-customer"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            domain: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.domain = domain;
        this.search.customer_id = this.customer_id;
        this.$store.dispatch("ProductType/get");
        this.$store.dispatch("SpecialCustomer/clearSearch")
    },
    computed: {
        ...mapState({
            special_customer_data: state => {
                return state.SpecialCustomer.special_customer_data;
            },
            search: state => {
                return state.SpecialCustomer.search;
            },
            dataPaginate: state => {
                return state.SpecialCustomer.dataPaginate;
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
        })
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show()
        },
        hideLoadingModal() {
            this.$refs.loading.hide()
        },
        printSpecialCustomerData() {
            if (this.search.date.length > 0 && this.search.date[0]) {
                this.search.start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                this.search.end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.start_date = '';
                this.search.end_date = '';
            }
            let customer_id = this.search.customer_id;
            let start_date = this.search.start_date;
            let end_date = this.search.end_date;
            let product_type_id = this.search.product_type_id;
            let data = {
                customer_id,
                start_date,
                end_date,
                product_type_id
            }
            //console.log(data);
            this.showLoadingModal();
            this.msg = 'กำลังค้นหาข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.$store.dispatch("SpecialCustomer/printSpecialCustomer", data).then(url => {
                if (url) {
                    window.open(url, '_blank')
                    this.hideLoadingModal();
                } else {
                    this.showLoadingModal();
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                }
            });
        },
        getSpecialCustomerPage(page) {
            if (this.search.date.length > 0 && this.search.date[0]) {
                this.search.start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                this.search.end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.start_date = '';
                this.search.end_date = '';
            }
            this.showLoadingModal();
            this.msg = 'กำลังค้นหาข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.$store.dispatch("SpecialCustomer/showCustomerSpecial", {
                page: page,
                data: {
                    customer_id: this.search.customer_id,
                    start_date: this.search.start_date,
                    end_date: this.search.end_date,
                    product_type_id: this.search.product_type_id ? this.search.product_type_id : '',
                }
            }).then(() => {
                this.hideLoadingModal();
            }).catch(err => {
                this.showLoadingModal();
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                this.status_loading = 3;
            });
        }
    }
}
</script>

<style scoped>
thead {
    background-color: darkgrey;
    color: black;
}

tbody {
    background-color: white;
}

tr {
    padding-left: 50px;
}
</style>
